import React, { useEffect } from "react";
import KeyboardDoubleArrowRightIcon from "@mui/icons-material/KeyboardDoubleArrowRight";
import price_img_1 from "../assets/Images/pricing_1.svg";
import price_img_2 from "../assets/Images/pricing_2.svg";
import { Link } from "react-router-dom";
const TermsConditions = () => {
    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });

    }, [])

    return (
        <>
            <title>Terms and Conditions | MagnAid Hospitals, Yousufguda</title>
            <meta name="description" content="Read the Terms and Conditions for using MagnAid Hospitals’ website and services. Know your rights, responsibilities, and our guidelines for safe interaction." />
            <div className="w-full flex flex-col justify-center md:pb-20 pb-8 items-center px-2 md:px-0 border-b-[1px]">
                <div className="xl:w-4/5  w-[90%] h-[200px] lg:h-[350px] flex justify-center  flex-col items-center rounded-3xl md:mt-8 mt-4 bg-verylightGreen relative overflow-hidden">
                    <div className="absolute -bottom-8 sm:bottom-0 right-0">
                        <img src={price_img_1} alt="" className="sm:w-auto w-20" />
                    </div>
                    <div className="absolute sm:top-0 sm:left-0 -left-5 -top-6">
                        <img src={price_img_2} alt="" className="sm:w-auto w-20" />
                    </div>
                    <h1 className="lg:text-[58px] md:text-[48px] text-[36px] text-center z-30 leading-[1.138em] font-heading text-thickGreen  mb-4">
                        Terms and Conditions
                    </h1>
                </div>
                <div className="xl:w-4/5  w-[90%]  mt-8">
                    <p className="mb-[24px] text-paraGreen md:text-[20px] text-lg md:px-3 px-0 font-body font-medium leading-[1.667em]  md:text-center text-left">
                        Welcome to MagnAid Hospitals. These terms and conditions ("Terms")
                        apply to all services provided by MagnAid Hospitals ("we", "us",
                        "our") to our patients and visitors ("you", "your"). By accessing or
                        using our services, you agree to be bound by these Terms. Please read
                        them carefully.
                    </p>
                    <div className="sm:px-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            1. Scope of Services
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            MagnAid Hospitals provides a variety of medical services including
                            but not limited to emergency care, inpatient and outpatient care,
                            diagnostic services, surgical procedures, and specialized medical
                            treatments.
                        </p>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            2. Eligibility
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            You must be at least 18 years old to use our services without
                            parental consent. Minors must be accompanied by a parent or legal
                            guardian who consents to these Terms on their behalf.
                        </p>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            3. Appointments and Cancellations
                        </h3>
                        <ul className="sm:px-2 my-3">
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Scheduling : </span>{" "}
                                    <span className="font-medium">
                                        Appointments can be scheduled through our website, by phone,
                                        or in person.
                                    </span>
                                </p>
                            </li>
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Cancellation Policy : </span>{" "}
                                    <span className="font-medium">
                                        Appointments must be cancelled at least 24 hours in advance.
                                        Failure to do so may result in a cancellation fee.
                                    </span>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            4. Privacy and Confidentiality
                        </h3>
                        <ul className="sm:px-2 my-3">
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Medical Records : </span>{" "}
                                    <span className="font-medium">
                                        Your medical records are confidential and will only be shared with your consent or as required by law.
                                    </span>
                                </p>
                            </li>
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Data Protection : </span>{" "}
                                    <span className="font-medium">
                                        We adhere to applicable data protection laws to ensure the security of your personal information.
                                    </span>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            5. Billing and Payment

                        </h3>
                        <ul className="sm:px-2 my-3">
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Insurance : </span>{" "}
                                    <span className="font-medium">
                                        We accept a variety of insurance plans. It is your responsibility to verify that your insurance plan covers our services.
                                    </span>
                                </p>
                            </li>
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Payment : </span>{" "}
                                    <span className="font-medium">
                                        Co-pays, deductibles, and any charges not covered by insurance are due at the time of service. We accept cash, credit cards, and other forms of payment as indicated on our website.
                                    </span>
                                </p>
                            </li>
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Billing Disputes : </span>{" "}
                                    <span className="font-medium">
                                        Any billing disputes must be reported within 30 days of receipt of the bill.
                                    </span>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            6. Patient Responsibilities

                        </h3>
                        <ul className="sm:px-2 my-3">
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Accurate Information : </span>{" "}
                                    <span className="font-medium">
                                        You must provide accurate and complete personal and medical information.
                                    </span>
                                </p>
                            </li>
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Compliance : </span>{" "}
                                    <span className="font-medium">
                                        You are responsible for following the treatment plan prescribed by your healthcare provider.
                                    </span>
                                </p>
                            </li>
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Respect : </span>{" "}
                                    <span className="font-medium">
                                        We expect all patients and visitors to treat our staff and other patients with respect and courtesy.
                                    </span>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            7. Visitor Policy
                        </h3>
                        <ul className="sm:px-2 my-3">
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Visiting Hours : </span>{" "}
                                    <span className="font-medium">
                                        Visiting hours are subject to change and are posted on our website and at our facilities.
                                    </span>
                                </p>
                            </li>
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Restrictions : </span>{" "}
                                    <span className="font-medium">
                                        Certain areas may have restricted access to ensure patient safety and privacy.
                                    </span>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            8. Limitation of Liability
                        </h3>
                        <ul className="sm:px-2 my-3">
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>General : </span>{" "}
                                    <span className="font-medium">
                                        MagnAid Hospitals will not be liable for any indirect, incidental, or consequential damages arising from the use of our services.
                                    </span>
                                </p>
                            </li>
                            <li className="my-2 md:text-[17px] flex flex-row gap-3  text-[15px] py-1 font-semibold text-paraGreen font-body">
                                {" "}
                                <span className="flex-shrink-0 text-orange">
                                    <KeyboardDoubleArrowRightIcon />
                                </span>
                                <p>
                                    <span>Medical Outcomes : </span>{" "}
                                    <span className="font-medium">
                                        While we strive to provide the highest quality of care, we do not guarantee specific medical outcomes.
                                    </span>
                                </p>
                            </li>
                        </ul>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            9. Complaints and Feedback
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            We value your feedback. Complaints and suggestions can be submitted via our website, by phone, or in person. We are committed to addressing any issues promptly and fairly.
                        </p>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            10. Changes to Terms
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            We reserve the right to modify these Terms at any time. Any changes will be posted on our website and will be effective immediately upon posting.
                        </p>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h3 className="md:text-2xl text-xl font-body font-bold text-lightGreen">
                            11. Governing Law
                        </h3>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            These Terms are governed by the laws of the jurisdiction in which MagnAid Hospitals operates.
                        </p>
                    </div>
                    <div className="sm:px-3 my-3">
                        <h2 className="md:text-3xl text-2xl font-body font-bold my-3 text-lightGreen">
                            Contact Us
                        </h2>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            For any questions or concerns regarding these Terms, please contact us at:
                        </p>
                        <div className="mt-4 flex my-3 flex-col">
                            <p className="sm:text-[18px] text-[16px] text-lightGreen font-body font-bold mb-[12px]">
                                Email address
                            </p>
                            <Link
                                to="mailto:info@magnaid.com"
                                className="text-[22px] text-thickGreen font-body font-medium"
                            >
                                info@magnaid.com
                            </Link>
                            <Link
                                to="mailto:magnaidhospitals@gmail.com"
                                className="text-[22px] text-thickGreen font-body font-medium"
                            >
                                magnaidhospitals@gmail.com
                            </Link>
                        </div>
                        <div className="my-[24px] border-b border-[#c4d6d6]"></div>
                        <div className="mb-10 lg:mb-0 mt-4 flex flex-col">
                            <p className="sm:text-[18px] text-[16px] text-lightGreen font-body font-bold mb-[12px]">
                                Phone number
                            </p>
                            <a
                                href="tel:7993999040"
                                className="text-[22px] text-thickGreen font-body font-medium"
                            >
                                7993 999 040
                            </a>
                            <a
                                href="tel:7993999044"
                                className="text-[22px] text-thickGreen font-body font-medium"
                            >
                                7993 999 044
                            </a>
                        </div>
                        <p className="my-4 text-paraGreen md:text-[20px] text-lg sm:px-3 font-body font-medium leading-[1.667em] ">
                            By accessing or using MagnAid Hospitals’ services, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
                        </p>
                    </div>
                </div>
            </div>
        </>
    );
};

export default TermsConditions;
